import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import footerBackground from '../assets/banner.jpg';

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path d="M22 12c0-5.522-4.477-10-10-10S2 6.478 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987H7.898v-2.89h2.54V9.797c0-2.507 1.492-3.89 3.778-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562v1.875h2.773l-.443 2.89h-2.33v6.987C18.343 21.128 22 16.991 22 12" />
  </svg>
);

const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path d="M22 5.924a7.542 7.542 0 0 1-2.2.603 3.84 3.84 0 0 0 1.678-2.122 7.66 7.66 0 0 1-2.43.95A3.806 3.806 0 0 0 11.08 7.4a10.792 10.792 0 0 1-7.83-3.993 3.78 3.78 0 0 0 1.176 5.077 3.81 3.81 0 0 1-1.72-.47v.047a3.812 3.812 0 0 0 3.047 3.734 3.81 3.81 0 0 1-1.713.064 3.814 3.814 0 0 0 3.559 2.645 7.642 7.642 0 0 1-4.74 1.637c-.309 0-.615-.018-.917-.054A10.787 10.787 0 0 0 9.5 20.04c7.086 0 10.957-5.872 10.957-10.957 0-.167-.004-.332-.012-.497A7.82 7.82 0 0 0 22 5.924" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path d="M12 7.35A4.65 4.65 0 1 0 16.65 12 4.656 4.656 0 0 0 12 7.35m0 7.66A3.01 3.01 0 1 1 15.01 12 3.014 3.014 0 0 1 12 15.01M17.85 6.2a1.085 1.085 0 1 0 1.085 1.085A1.088 1.088 0 0 0 17.85 6.2m3.08 1.1a5.353 5.353 0 0 0-1.457-3.8 5.389 5.389 0 0 0-3.8-1.458c-1.496-.085-5.984-.085-7.481 0a5.379 5.379 0 0 0-3.8 1.458A5.362 5.362 0 0 0 2.943 7.3c-.085 1.5-.085 5.984 0 7.482a5.353 5.353 0 0 0 1.458 3.8 5.397 5.397 0 0 0 3.8 1.458c1.5.085 5.984.085 7.481 0a5.383 5.383 0 0 0 3.8-1.458 5.359 5.359 0 0 0 1.458-3.8c.085-1.5.085-5.983 0-7.481M21.4 15.9a3.553 3.553 0 0 1-.864 2.515 3.582 3.582 0 0 1-2.515.864c-1.456.082-5.822.082-7.279 0a3.578 3.578 0 0 1-2.515-.864 3.56 3.56 0 0 1-.864-2.514c-.082-1.457-.082-5.823 0-7.28a3.557 3.557 0 0 1 .864-2.514 3.594 3.594 0 0 1 2.515-.865c1.457-.082 5.823-.082 7.28 0a3.567 3.567 0 0 1 2.515.865 3.542 3.542 0 0 1 .864 2.514c.081 1.457.081 5.823 0 7.28" />
  </svg>
);

const Footer = () => {
  return (
    <footer
      className="footer"
      style={{ backgroundImage: `linear-gradient(rgba(36, 38, 58, 0.92), rgba(36, 38, 58, 0.92)), url(${footerBackground})` }}
    >
      <Container>
        <Row className="footer-top">
          <Col md={6} lg={4} className="footer-social">
            <h5>Socials:</h5>
            <div className="footer-divider" />
            <div className="footer-social-icons">
              <a
                href="https://www.facebook.com/counseling.hoperoad/"
                aria-label="Hope Road on Facebook"
                target="_blank"
                rel="noreferrer"
              >
                <FacebookIcon />
              </a>
              <a
                href="https://twitter.com/1hoperoad"
                aria-label="Hope Road on Twitter"
                target="_blank"
                rel="noreferrer"
              >
                <TwitterIcon />
              </a>
              <a
                href="https://www.instagram.com/1hoperoad"
                aria-label="Hope Road on Instagram"
                target="_blank"
                rel="noreferrer"
              >
                <InstagramIcon />
              </a>
            </div>
            <a
              className="footer-link"
              href="https://storage.googleapis.com/wzukusers/user-35406855/documents/c45d21b8303e4bf59a15f0405b184674/HIPAAWEB.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </Col>
          <Col md={6} lg={{ span: 4, offset: 4 }} className="footer-contact">
            <p>1570 Lakeview Drive, Suite 2B</p>
            <p>Sebring, FL 33870</p>
            <p>Phone: 863-633-HOPE (4673)</p>
          </Col>
        </Row>
        <Row className="footer-bottom text-center">
          <Col>

            {/* fix this so the text is centered. */}
            <div className="text-center mb-2">
              Hope Road Counseling is in-network with Aetna, Cigna, UnitedHealthcare, Oscar Health, and Oxford Insurance Plans, and accepts most EAP benefits. Payment options include Cash, Visa, Mastercard, American Express, and Discover.
            </div>
           
            <p className="mb-2">
             All rights reserved © Hope Road
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
